/* global __CORECRY_CLIENT_RELEASE__ */
import { monotonicNow, visible, browserOnline } from './websocketLifecycle.js'

export const socketId = () => globalThis.crypto?.randomUUID?.() || `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`

export class WebSocketDiagnostics {
    constructor(service) {
        this.service = service
        this.tabId = socketId()
        this.incident = null
        this.lastSummary = 0
    }
    write(code, cause, extra = {}, level = 'info') {
        const s = this.service
        const now = monotonicNow()
        globalThis.clientLogger?.[level](code, `WebSocket ${code.slice(3).replaceAll('_', ' ')}`, {
            component: 'WebSocketService', diagnostics: {
                diagnostic_version: 1, tab_id: this.tabId, incident_id: this.incident?.id,
                client_release: typeof __CORECRY_CLIENT_RELEASE__ === 'undefined' ? 'local' : __CORECRY_CLIENT_RELEASE__,
                connection_id: s.connectionId, ...s.serverIdentity,
                occurred_at: new Date().toISOString(), cause,
                confidence: ['unknown_abnormal', 'timer_gap', 'legacy_receive_timeout'].includes(cause) ? 'unknown' : 'observed',
                visibility: visible() ? 'visible' : 'hidden', browser_online: browserOnline(),
                protocol: s.heartbeat.negotiated ? 'ack_v2' : 'legacy',
                incoming_age_ms: Math.max(0, now - s.heartbeat.lastIncoming),
                ack_age_ms: s.heartbeat.lastAck === null ? null : Math.max(0, now - s.heartbeat.lastAck),
                rtt_ms: s.heartbeat.rtt, timer_lag_ms: s.timerLagMs || 0,
                attempts: s.reconnectAttempts, duration_ms: this.incident ? Math.max(0, now - this.incident.started) : 0,
                ...extra,
            },
        })
    }
    failed(cause, extra = {}) {
        const first = !this.incident
        if (first) this.incident = { id: socketId(), started: monotonicNow() }
        if (first || monotonicNow() - this.lastSummary >= 300000) {
            this.lastSummary = monotonicNow()
            this.write(first ? 'ws_interrupted' : 'ws_retry_summary', cause, extra, 'warn')
        }
    }
    recovered() {
        if (this.incident) this.write('ws_recovered', 'connection_verified')
        this.incident = null
    }
    lifecycle(cause) {
        this.incident ||= { id: socketId(), started: monotonicNow() }
        this.write('ws_lifecycle', cause, { initiator: 'client' })
    }
}
